<template>
  <div class="auth" id="auth" name="auth">
    <div class="top">
      <NavTop activeIndex="3"></NavTop>
    </div>
    <div class="content-box">
      <div class="">
        <div class="">身份证正面</div>
        <el-upload
          class="upload-demo"
          action="https://476.new.lingchuang.co/api/common/upload"
          :on-success="onSuccess1"
          :headers="headers"
          :show-file-list="false"
        >
          <div
            class=""
            style="display: flex; align-items: center; margin-top: 30px"
          >
            <img
              :src="frontCard"
              alt=""
              style="width: 80px; height: 80px; border: 1px solid #ddd"
              v-if="frontCard"
            />
            <div
              class=""
              style="
                width: 80px;
                height: 80px;
                border: 1px solid #ddd;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 5px;
                margin-right: 20px;
              "
              v-else
            >
              <i class="el-icon-plus" style="font-size: 40px; color: #ddd"></i>
            </div>
            <div slot="tip" class="el-upload__tip">
              仅支持上传 .png .jpg .gif格式的文件
            </div>
          </div>
        </el-upload>
      </div>

      <div class="">
        <div class="">身份证反面</div>
        <el-upload
          class="upload-demo"
          action="https://476.new.lingchuang.co/api/common/upload"
          :on-success="onSuccess2"
          :headers="headers"
          :show-file-list="false"
        >
          <div
            class=""
            style="display: flex; align-items: center; margin-top: 30px"
          >
            <img
              :src="reverseCard"
              alt=""
              style="width: 80px; height: 80px; border: 1px solid #ddd"
              v-if="reverseCard"
            />
            <div
              class=""
              style="
                width: 80px;
                height: 80px;
                border: 1px solid #ddd;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 5px;
                margin-right: 20px;
              "
              v-else
            >
              <i class="el-icon-plus" style="font-size: 40px; color: #ddd"></i>
            </div>
            <div slot="tip" class="el-upload__tip">
              仅支持上传 .png .jpg .gif格式的文件
            </div>
          </div>
        </el-upload>
      </div>
      <div class="">
        <div class="">手持身份证</div>
        <el-upload
          class="upload-demo"
          action="https://476.new.lingchuang.co/api/common/upload"
          :on-success="onSuccess3"
          :headers="headers"
          :show-file-list="false"
        >
          <div
            class=""
            style="display: flex; align-items: center; margin-top: 30px"
          >
            <img
              :src="handHeld"
              alt=""
              style="width: 80px; height: 80px; border: 1px solid #ddd"
              v-if="handHeld"
            />
            <div
              class=""
              style="
                width: 80px;
                height: 80px;
                border: 1px solid #ddd;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 5px;
                margin-right: 20px;
              "
              v-else
            >
              <i class="el-icon-plus" style="font-size: 40px; color: #ddd"></i>
            </div>
            <div slot="tip" class="el-upload__tip">
              仅支持上传 .png .jpg .gif格式的文件
            </div>
          </div>
        </el-upload>
      </div>
      <el-button
        size="medium"
        type="info"
        style="
          width: 270px;
          height: 40px;
          padding: 0;
          border-radius: 5px;
          background-color: #4b72f6;
          border: none;
          color: #666 !important;
        "
        round
        @click="submit"
        >确定</el-button
      >
    </div>
  </div>
</template>
<script>
import NavTop from "../components/NavTopWhit.vue";
import Cookies from "js-cookie";
import { applyLiver } from "../api/user";
export default {
  components: {
    NavTop,
  },
  data() {
    return {
      LoginUser: { name: "" },

      headers: {
        token: localStorage.getItem("token"),
      },
      frontCard: "",
      reverseCard: "",
      handHeld: "",
    };
  },
  methods: {
    submit() {
      if (!this.frontCard) {
        this.$message({
          message: "请上传身份证正面照片",
          type: "warning",
        });
        return;
      }
      if (!this.reverseCard) {
        this.$message({
          message: "请上传身份证反面照片",
          type: "warning",
        });
        return;
      }
      if (!this.handHeld) {
        this.$message({
          message: "请上传手持身份证",
          type: "warning",
        });
        return;
      }
      let data = {
        frontCard: this.frontCard,
        reverseCard: this.reverseCard,
        handHeld: this.handHeld,
      };
      applyLiver(data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: "申请成功,请等待审核",
            type: "warning",
          });
        }
      });
    },
    onSuccess1(files, filList) {
      console.log("上传成功的", files.data.fullurl, filList);
      this.frontCard = files.data.fullurl;
    },
    onSuccess2(files, filList) {
      console.log("上传成功的", files, filList);
      this.reverseCard = files.data.fullurl;
    },
    onSuccess3(files, filList) {
      console.log("上传成功的", files, filList);
      this.handHeld = files.data.fullurl;
    },
  },
};
</script>
<style scoped>
.content-box {
  width: 1200px;
  margin: 80px auto 0;
  padding-top: 30px;
  background-color: #fff;
  min-height: 500px;
}

.el-form {
  width: 500px;
  margin: 0 auto;
  border: 1px solid #000;
}
</style>
